import { useTranslation } from 'react-i18next';
import './Registration.css';
import Grid from '../../components/grid/Grid';
import { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { getAssetsForRegistration, approveAsset, rejectAsset } from '../../services/AssetRegistrationAPI';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Registration = () => {
    const { t } = useTranslation();
    const [selectedRows, setSelectedRows] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const headers = [
        { key: 'modelNumber', label: 'Model', width: '50%' },
        { key: 'serialNumber', label: 'Serial Number', width: '50%' },
    ];

    const mapApiResponseToGridData = (dataArray) => {
        return dataArray.map((item, index) => ({
            id: index + 1,
            modelNumber: item.parameters?.DeviceModel ?? item.analyzer_model ?? '',
            serialNumber: item.parameters?.DeviceSerial ?? item.system_serial_number ?? ''
        }));
    };
    const loadData = async () => {
        try {
            setLoading(true);
            const raw = await getAssetsForRegistration();  // Fetch real data from signed AWS request
            const formatted = Array.isArray(raw) ? raw : [raw]; // Ensure it's an array
            const mapped = mapApiResponseToGridData(formatted);
            setData(mapped);
        } catch (err) {
            console.error('Fetch failed:', err);
        } finally {
            setLoading(false);
        }
    };


    const handleAction = async (action) => {
        if (selectedRows.length === 0) return;

        const status = action === 'approve' ? 'APPROVED' : 'REJECTED';

        const asset_ids= selectedRows.map(row => `${row.modelNumber}@${row.serialNumber}`);

        const payload = {
            status,
            asset_ids
        };

        try {
            

            if (action === 'approve') {
                await approveAsset(payload);
                toast.success(`Approved ${asset_ids.length} assets`);
            } else {
                await rejectAsset(payload);
                toast.info(`Rejected ${asset_ids.length} assets`);
            }
        } catch (err) {
            toast.error(`Failed with unkown error`);
            console.error('Registraion Action failed:', err);
        }

        await loadData();
    };

    
    useEffect(() => {
        loadData();
    }, []);


    
    return (
        <div className='reg-page-wrapper'>
            <div className='reg-header'>
                <h4>{t('Asset Registration')}</h4>
            </div>
            <div className="d-flex justify-content-center my-2">
                <Button className="mx-2 btn-primary" disabled={selectedRows.length === 0} onClick={() => handleAction('approve')}>
                    {t('Accept')}
                </Button>
                <Button className="mx-2 btn-info" disabled={selectedRows.length === 0} onClick={() => handleAction('reject')}>
                    {t('Reject')}
                </Button>
            </div>
            <div className='reg-content'>
                <Grid
                    headers={headers}
                    data={data}
                    rowsPerPage={50}
                    canMultiSelect={true}
                    onSelectionChange={setSelectedRows}
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default Registration;
